import { IconButton, Stack } from "@mui/material";
import WushSortableTable from "../../layout/WushSortableTable";
import { useNavigate } from "react-router-dom";
import WushPopover from "../../layout/WushPopover";
import { Delete, Edit } from "@mui/icons-material";
import DeleteConfirmation from "../../form/DeleteConfirmation";
import WaiverForm from "../../form/waiver/WaiverForm";

export default function WaiverTable({ handleDelete, waivers }) {
  const navigate = useNavigate();

  return (
    <Stack>
      <WushSortableTable
        title="Waivers"
        onRowClick={(row) => navigate(`/configuration/waivers/${row.id}`)}
        headers={[
          {
            id: 1,
            key: "id",
            label: "ID"
          },
          {
            id: 2,
            key: "name",
            label: "Name"
          },
          {
            id: 3,
            key: "description",
            label: "Description"
          },
          {
            id: 4,
            label: "Actions",
            customValue: (row) => console.log(row) || (
              <Stack direction="row">
                <WushPopover
                  anchor={
                    <IconButton>
                      <Edit />
                    </IconButton>
                  }
                >
                  <Stack
                    p={2}
                  >
                    <WaiverForm waiver={row} />
                  </Stack>
                </WushPopover>
                {row.deletable && handleDelete && <DeleteConfirmation handleDelete={() => handleDelete(row)}>
                  <IconButton>
                    <Delete />
                  </IconButton>
                </DeleteConfirmation>}
              </Stack>
            )
          }
        ]}
        data={waivers}
      />
    </Stack>
  );
}